import type { TPredefinedAnimations } from './definitions'

const anims: TPredefinedAnimations = {
  fadeIn: { opacity: [ 0, 1 ] },
  fadeOut: { opacity: [ 1, 0 ] }
}

export default anims
